import _ from 'lodash';

import PropTypes from 'prop-types';

import { cmsService } from '../services/homii-services';

import BlogPostHeader from '../components/blog-components/blog-post-header.component';

import BlogPostBody from '../components/blog-components/blog-post-body.component';

import ContactFormSection from '../components/lead-gen-components/contact-form-section.component';

import { Layout, MetaData, Footer } from '../components/shared';

import { marketingDomain } from '../domain/';

const Post = (props) => {

    const { data, page, blogPage, campaignData } = props;

    const {
        seo_title,
        seo_meta_description,
        url_slug,
        meta_data_publish_date,
        meta_data_tags,
    } = data;

    const formRoomTypeCategoriesData = _.get(blogPage, 'acf.room_type_categories');
    const formFurnishingOptionsData = _.get(blogPage, 'acf.furnishing');
    const contactFormTitle = _.get(blogPage, 'acf.contact_form_section_title');
    const contactFormParagraph = _.get(blogPage, 'acf.contact_form_section_paragraph');
    const campaignName = `Blog: ${seo_title}`;

    return (

        <Layout>

            <MetaData
                title={seo_title}
                desc={seo_meta_description}
                canonical={`/blog/post${url_slug}`}
            />

            <BlogPostHeader
                title={seo_title}
                published={meta_data_publish_date}
                tags={meta_data_tags}
            />
            
            <BlogPostBody data={data} page={page} />

            <div className='container-root container-root-maxWidthLg'>
                <ContactFormSection
                    title={contactFormTitle}
                    paragraph={contactFormParagraph}
                    campaignName={campaignName}
                    formRoomTypeCategoriesData={formRoomTypeCategoriesData}
                    formFurnishingOptionsData={formFurnishingOptionsData}
                    campaignData={campaignData}
                />
            </div>

            <Footer />

        </Layout>
    );
};

export default Post;

export const getServerSideProps = async ({ query }) => {
    const page = parseInt(query.page || 1);
    const resp = await cmsService.RetrieveWordPressPost(query.slug);
    const blogPage = await cmsService.RetrieveWordPressPage('blog');
    const data = _.get(resp, 'acf');
    const campaignData = await marketingDomain.getMarketingCampaignDataByName('default');
    return {
        props: {
            data, page, blogPage, campaignData
        }
    }
};

Post.propTypes = {
    data: PropTypes.object,
    page: PropTypes.any,
    blogPage: PropTypes.object,
    campaignData: PropTypes.object,
};
